import { useIntl } from "react-intl";

import { getTravelerType } from "@/features/travellers/utils/transformTraveler";

export function TravelerTypeLabel(props: { birthDate: string }) {
  const type = getTravelerType(props.birthDate);
  const intl = useIntl();

  if (type === "adult") {
    return intl.formatMessage({
      id: "travellers.adult",
      defaultMessage: "Adult",
    });
  }

  if (type === "child") {
    return intl.formatMessage({
      id: "travellers.child",
      defaultMessage: "Child",
    });
  }

  return intl.formatMessage({
    id: "travellers.infant",
    defaultMessage: "Infant",
  });
}
